import script from "./AppTextEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTextEditor.vue?vue&type=script&setup=true&lang=js"

import "./AppTextEditor.vue?vue&type=style&index=0&id=13aba720&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13aba720"]])

export default __exports__